import { render, staticRenderFns } from "./CommonButtonIcon.vue?vue&type=template&id=2ef2a4d8&scoped=true&"
import script from "./CommonButtonIcon.vue?vue&type=script&lang=js&"
export * from "./CommonButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./CommonButtonIcon.vue?vue&type=style&index=0&id=2ef2a4d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2a4d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
